import { Combobox } from '@headlessui/react';
import type { HighlitOption } from './types';
import { Fragment } from 'react';
import { getOptionClasses } from './utils';

function HighlitLabel({ option }: { option: HighlitOption }) {
	if (option.startIndex === -1) {
		return <>{option.label}</>;
	}

	return (
		<>
			{option.label.slice(0, option.startIndex)}
			<span className="font-bold">
				{option.label.slice(option.startIndex, option.endIndex)}
			</span>
			{option.label.slice(option.endIndex)}
		</>
	);
}

export default function Option({ option }: { option: HighlitOption }) {
	return (
		<Combobox.Option as={Fragment} key={`${option.value}`} value={option}>
			{({ active }) => (
				<li className={getOptionClasses(active)}>
					<HighlitLabel option={option} />
				</li>
			)}
		</Combobox.Option>
	);
}
